import { useState } from 'react';
import { motion } from 'motion/react';
import { EASE_SOFT } from '@/lib/motion';

const NAMES = ['RK', 'Nishan'] as const;

/**
 * Footer credit with a quiet easter egg. Renders "Made by RK"; the initials are
 * actually a button styled to be indistinguishable from the surrounding text
 * (inherits font/colour, text cursor, no hover state). Clicking spins them a
 * full turn and swaps RK ⇄ Nishan mid-spin, and vice-versa.
 */
export function MadeBy() {
  const [clicks, setClicks] = useState(0);
  const [name, setName] = useState<(typeof NAMES)[number]>(NAMES[0]);

  const spin = () => {
    const next = clicks + 1;
    setClicks(next);
    // Swap the label at roughly the midpoint of the rotation.
    window.setTimeout(() => setName(NAMES[next % NAMES.length] ?? NAMES[0]), 180);
  };

  return (
    <span>
      Made by{' '}
      <button
        type="button"
        onClick={spin}
        aria-label="Toggle the maker's name"
        className="cursor-text appearance-none border-0 bg-transparent p-0 font-[inherit] leading-[inherit] tracking-[inherit] text-[inherit] text-current"
      >
        <motion.span
          className="inline-block"
          animate={{ rotate: clicks * 360 }}
          transition={{ duration: 0.5, ease: EASE_SOFT }}
        >
          {name}
        </motion.span>
      </button>
    </span>
  );
}
